import type { FeedBudgetPlan } from "./types";

/** Plan-level grazing month rows (growth + utilisation); used across planner UI */
export type GrazingMonths = FeedBudgetPlan["grazingMonths"];

/**
 * Set growth rate for a specific (month, yearOffset). Updates an existing row or
 * appends one, copying utilisation from the matching year‑0 row (or same month fallback).
 */
export function upsertGrazingMonthGrowthRate(
  grazingMonths: GrazingMonths,
  month: number,
  yearOffset: 0 | 1,
  value: number
): GrazingMonths {
  const nextGrowth = Math.max(0, value);
  const hasTarget = grazingMonths.some(
    (gm) => gm.month === month && (gm.yearOffset ?? 0) === yearOffset
  );
  if (hasTarget) {
    return grazingMonths.map((gm) =>
      gm.month === month && (gm.yearOffset ?? 0) === yearOffset
        ? { ...gm, growthRateKgHaDay: nextGrowth }
        : gm
    );
  }
  const fallback =
    grazingMonths.find(
      (gm) => gm.month === month && (gm.yearOffset ?? 0) === 0
    ) ?? grazingMonths.find((gm) => gm.month === month);
  return [
    ...grazingMonths,
    {
      month,
      yearOffset,
      growthRateKgHaDay: nextGrowth,
      utilisationPercent: fallback?.utilisationPercent ?? 0,
    },
  ];
}
